// extracted by mini-css-extract-plugin
module.exports = {"links":"usernamePasswordForm_links__naSc1","link":"usernamePasswordForm_link__Xc6y_"};